module.exports = {
    nav: {
        home: 'Главная страница',
        about: 'О компании',
        yan: 'Услуга платформ',
        pro: 'продукты',
        new: 'Центр новостей.',
        jabout: 'Присоединяйтесь к нам',
        contact: 'Свяжись с нами.',
        iupt:'Поиск по номеру CAS, названию продукции, английскому имени',
    },
    indexs:{
        aouts:'О небесной ронде',
        ke:'исследователь',
        gao:'50%Талант высшего образования',
        pins:"О небесной ронде",
        success:'Успешный аудит',
        shun:'ПройденаFDA、NMPA',
        tga:'TGA MFDS рассмотреть',
        quan:'мир клиент',
        lc:'600 клинических проектов',
        zai:"Коммерческий проект в процессе",
        zl:'патент',
        zlsl:'Количество патентов продолжает расти, охватывая США,',
        orzh:"Европа, Япония, Китай и Южная Корея",
        fwfc:'услуги',
        hese:'Сотрудничество в создании инноваций',
        zqyp:'Быть партнером в исследованиях и исследованиях в мировом фармацевтическом производстве, начиная с каждого, каждого продукта, каждого обслуживания.',
    },
    about:{
        abCen:'Профиль компании',
        zhjia:'Команда экспертов',
        zhl:'масса соблюдение',
        qiwen:'Корпоративная культура',
        tihxd:'господи',
        fwts:'Сервисные функции',
        shi:'Наша миссия.',
        hz:'Сотрудничество в создании инноваций',
        yj:'Наше видение.',
        zqiu:'Быть партнером в исследованиях и исследованиях в мировом фармацевтическом производстве, начиная с каждого, каждого продукта, каждого обслуживания',
    },
   
    pro:{
        cash:'cas псевдоним',
        zname:'китайское имя',
        fzs:'формула',
        jgs:'структурная формула',
        proxi:'информация продуктов',
        yname:'английский',
        fzl:'Молекулярная масса',
        cpsx:'Свойства товара',
        yd:'температура плавления',
        fd:'точка кипения',
        md:'консистенция',
        zdp:'показатель преломления',
        sd:'молния',
        zctj:'условия хранения',
        aqxx:'Turn Off Security Messages',
        wxxfh:'Пиктограммы опасности СГС',
   
        wxxbm:'Категория опасности',
        hgbm:'HS CODE /HS',
        ckwx:'ссылки',
        xiazai:'скачать',
        cdzl:'Скачивание отчетов по чистоте продукции',
    },
    join:{
        zw:'пост',
        bm:'область',
        dd:'место',
        yq:'просить',
    },
    cont:{
        ywzx:'Бизнес-консалтинг',
        gszj:'HOWO',
        gnywe:'Внутренний почтовый ящик',
        fzgw:'Отвечает за получение внутренних клиентов, техническое консультирование электронной почты',
        cz:'Факс',
        zjyx:'Почтовый ящик по делам ценных бумаг',
        lxdh:'телефон',
        yx:'почтовый',
        help:'Чем мы можем вам помочь',
        jdlxfs:'Пожалуйста, заполните следующие короткие формы для связи',
        mz:'личное имя',
        xing:'фамилия',
        zc:'работа',
        gs:'компания',
        yj:'почта',
        dh:'телефон',
        gj:'страна',
        gxqfw:'Заинтересованная служба',
        zs:'Комментарии',
        wjsc:'Загрузка файлов',
        sbum:'представить',
        gs:'компания',
        bgxz:'скачать',
        rgyw:'Если есть консультация по вопросам бизнеса, она может быть загружена и передана нам после заполнения анкета.',
        xjd:'Список цен.',
        bzh:'Гарантийное письмо',
        wjsc:'Загрузка файлов',
        djsc:'Нажми на загрузку.',
    },
    more:'сморщивание',
    news:'Новости компании',
    td:'Способ доставки резюме',
    zwlb:'Список должностей.',
    email:'почтовый',
    ell:'телефон',
    zpyq:'Подбор персонала',
    gzzw:'обязанности',
    zpxi:'Подбор персонала',
    ywzx:'Бизнес-консалтинг',
    dz:'адрес',
    
}


// WEBPACK FOOTER //
// ./src/utils/lang/ru.js